import { create } from 'zustand';

export type LayoutStore = {
  unpadded: boolean;
  setUnpadded: (unpadded: boolean) => void;
};

/**
 * Zustand store to manage layout state, specifically the 'unpadded' property.
 * This store allows components to toggle padding in the layout dynamically.
 */
export const useLayoutStore = create<LayoutStore>((set) => ({
  unpadded: false,
  setUnpadded: (unpadded) => set({ unpadded }),
}));
